<template>
  <div>
    <AccordionCard :state="cards.serviceStringPlanAttachments">
      <template v-slot:header>
        {{ $t('stringPlanAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('stringPlanAttachments') }}
        </div>
        <div class="flex-column select">
          {{ $t('stringPlanAttachments_description') }}

          {{ $t('panelBottomViewAttachments_description') }} <br />
          {{ $t('templateAttachments') }}:
          <AttachmentGallery
            :attachments="referenceData.reportTemplateImages[47].templateAttachments"
            :deletable="false"
            :sortByName="false"
            :showFilename="false"
          ></AttachmentGallery>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.serviceStringPlanAttachments"
            attachmentType="serviceStringPlanAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isstringPlanAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="serviceStringPlanAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isstringPlanAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.stringPlanAvailableState">
      <template v-slot:header>
        {{ $t('stringPlanAvailableState') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('stringPlanAvailableState') }}
        </div>
        <div class="flex-column select">
          <SelectButton
            :disabled="isBlockReadOnly"
            v-model="project.serviceReport.stringPlanAvailableState"
            :options="getEnumValues('YesNo')"
          >
            <template #option="props">
              {{ $t(props.option) }}
            </template>
          </SelectButton>
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.serviceAllPanelsVisibleAttachments">
      <template v-slot:header>
        {{ $t('allPanelsVisibleAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('allPanelsVisibleAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[37].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.serviceAllPanelsVisibleAttachments"
            attachmentType="serviceAllPanelsVisibleAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isallPanelsVisibleAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="serviceAllPanelsVisibleAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isallPanelsVisibleAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.serviceClampAreaAttachments">
      <template v-slot:header>
        {{ $t('clampAreaAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('clampAreaAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[40].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.serviceClampAreaAttachments"
            attachmentType="serviceClampAreaAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isclampAreaAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="serviceClampAreaAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isclampAreaAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.serviceTrayfDistanceAttachments">
      <template v-slot:header>
        {{ $t('trayfDistanceAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('trayfDistanceAttachments') }}</div>
        <div class="flex-column select">
          <div>
            {{ $t('templateAttachments') }}:
            <AttachmentGallery
              :attachments="referenceData.reportTemplateImages[30].templateAttachments"
              :deletable="false"
              :sortByName="false"
              :showFilename="false"
            ></AttachmentGallery>
          </div>
        </div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.serviceTrayfDistanceAttachments"
            attachmentType="serviceTrayfDistanceAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="istrayfDistanceAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="serviceTrayfDistanceAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="istrayfDistanceAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.serviceRailOverlapAttachments">
      <template v-slot:header>
        {{ $t('serviceRailOverlapAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">{{ $t('serviceRailOverlapAttachments') }}</div>
      </div>

      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.serviceRailOverlapAttachments"
            attachmentType="serviceRailOverlapAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="isserviceRailOverlapAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="serviceRailOverlapAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="isserviceRailOverlapAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCard :state="cards.servicePanelBottomViewAttachments">
      <template v-slot:header>
        {{ $t('panelBottomViewAttachments') }}
      </template>

      <div class="flex-row">
        <div class="flex-column name">
          {{ $t('panelBottomViewAttachments') }}
        </div>
        <div class="flex-column select">
          {{ $t('panelBottomViewAttachments_description') }} <br />
          {{ $t('templateAttachments') }}:
          <AttachmentGallery
            :attachments="referenceData.reportTemplateImages[33].templateAttachments"
            :deletable="false"
            :sortByName="false"
            :showFilename="false"
          ></AttachmentGallery>
        </div>
      </div>
      <div class="flex-row">
        <div class="flex-column name"></div>
        <div class="flex-column select">
          <AttachmentGallery
            :attachments="project.servicePanelBottomViewAttachments"
            attachmentType="servicePanelBottomViewAttachments"
            :deletable="!isBlockReadOnly"
            :hidesDeleteForGuests="!isOrganizationRoleNavigationEnabled"
            v-on:attachment-list:delete="onDeleteProjectAttachment"
            :sortByName="false"
          ></AttachmentGallery>
          <DropzoneUpload
            v-if="!isBlockReadOnly"
            class="mt-2"
            :complete="ispanelBottomViewAttachmentsUploadComplete"
            :parentId="project.id"
            parentType="servicePanelBottomViewAttachments"
            :uploadCallback="onUploadProjectAttachment"
            v-on:dropzone-upload:reset="ispanelBottomViewAttachmentsUploadComplete = false"
            acceptedFileTypes="image/*"
          />
        </div>
      </div>
    </AccordionCard>

    <AccordionCardOptionalInput
      :card="cards.serviceSolarPanelsOptionalAttachments"
      :project="project"
      reportPath="serviceReport"
      notesType="solarPaneldOptionalNotes"
      :attachments="project.serviceSolarPanelsOptionalAttachments"
      attachmentType="serviceSolarPanelsOptionalAttachments"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { AccessBlockMixin } from '@/mixins/accessBlock';
import AccordionCard from '@/components/AccordionCard';
import AccordionCardOptionalInput from '@/components/AccordionCardOptionalInput';
import AttachmentGallery from '@/components/AttachmentGallery';
import DropzoneUpload from '@/components/DropzoneUpload';
import SelectButton from 'primevue/selectbutton';

export default {
  name: 'ExistingDamage',
  components: {
    AccordionCard,
    AttachmentGallery,
    DropzoneUpload,
    AccordionCardOptionalInput,
    SelectButton,
  },
  mixins: [AccessBlockMixin],
  props: {
    project: { type: Object },
    cards: { type: Object },
    /**
     * Template images from `MobileProjectsServiceReport` (block field, or the store getter outside
     * the block).
     */
    referenceData: { type: Object, default: () => ({ reportTemplateImages: [] }) },
  },
  data() {
    return {
      /** track Upload states for clearing dropzone preview */
      isstringPlanAttachmentsUploadComplete: false,
      isallPanelsVisibleAttachmentsUploadComplete: false,
      ispanelBottomViewAttachmentsUploadComplete: false,
      israilOverlapAttachmentsUploadComplete: false,
      isclampAreaAttachmentsUploadComplete: false,
      istrayfDistanceAttachmentsUploadComplete: false,
      isserviceRailOverlapAttachmentsUploadComplete: false,
    };
  },
  computed: {
    ...mapGetters(['getEnumValues']),
    ...mapGetters('auth', ['isOrganizationRoleNavigationEnabled']),
    isPitchedRoof() {
      return this.project.measurement && this.project.measurement.roofType === 'PITCHED_ROOF';
    },
  },

  methods: {
    ...mapActions(['uploadProjectAttachment', 'deleteProjectAttachment']),

    async onUploadProjectAttachment(payload) {
      await this.uploadProjectAttachment(payload);
    },

    async onDeleteProjectAttachment(event) {
      await this.deleteProjectAttachment({
        projectId: this.project.id,
        attachmentId: event.attachmentId,
        attachmentType: event.attachmentType,
      });
    },
  },
  async mounted() {
    // after upload is complete emit event to clear dropzone preview
    this.$store.subscribeAction({
      after: (action, state) => {
        if (action.type === 'uploadProjectAttachment') {
          this.isstringPlanAttachmentsUploadComplete = true;
          this.isallPanelsVisibleAttachmentsUploadComplete = true;
          this.ispanelBottomViewAttachmentsUploadComplete = true;
          this.israilOverlapAttachmentsUploadComplete = true;
          this.isclampAreaAttachmentsUploadComplete = true;
          this.istrayfDistanceAttachmentsUploadComplete = true;
          this.isserviceRailOverlapAttachmentsUploadComplete = true;
        }
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>
